interface Props {
  children?: React.ReactNode;
}

export function FilterRowCharts({ children }: Props) {
  return (
    <div className="flex flex-row items-center justify-center gap-10">
      {children}
    </div>
  );
}